enum PolicyRequired {
  required = "REQUIRED",
  policy = "POLICY",
  not_required = "NOT_REQUIRED",
}

export default PolicyRequired;
